import React, { useState, useEffect } from 'react';
import axios from '../../../Data/Axios';
import './index.scss';
import { useSession } from '@/Recoil/Session/Session';
import TopikImage from '@/Components/Product/TopikImage';
import { tLoader } from '@/Utils/i18n';
import { languageManager } from '@/Utils/languageManager';

const translations = {
    en: {
        "Monday": "Monday",
        "Tuesday": "Tuesday",
        "Wednesday": "Wednesday",
        "Thursday": "Thursday",
        "Friday": "Friday",
        "Saturday": "Saturday",
        "Sunday": "Sunday",
        "Mon": "Mon",
        "Tue": "Tue",
        "Wed": "Wed",
        "Thu": "Thu",
        "Fri": "Fri",
        "Sat": "Sat",
        "Sun": "Sun",
        "Please fill in all fields": "Please fill in all fields",
        "Survey submitted successfully! We will contact you when the session is ready.": "Survey submitted successfully! We will contact you when the session is ready.",
        "Error submitting survey. Please try again.": "Error submitting survey. Please try again.",
        "Join TOPIK Session": "Join TOPIK Session",
        "Preferred Weekdays": "Preferred Weekdays",
        "My WhatsApp Number": "My WhatsApp Number",
        "Submitting...": "Submitting...",
        "Submit": "Submit",
        "⚠️ Penting:": "⚠️ Important:",
        " Sesi terdiri dari 10 orang dengan sistem first come first served, dan jika sesi sudah terpenuhi, detail sesi dan link pembayaran akan dikirimkan kepada Anda.": " Session consists of 10 people on a first-come-first-served basis, and when the session is full, session details and payment link will be sent to you."
    },
    id: {
        "Monday": "Senin",
        "Tuesday": "Selasa",
        "Wednesday": "Rabu",
        "Thursday": "Kamis",
        "Friday": "Jumat",
        "Saturday": "Sabtu",
        "Sunday": "Minggu",
        "Mon": "Sen",
        "Tue": "Sel",
        "Wed": "Rab",
        "Thu": "Kam",
        "Fri": "Jum",
        "Sat": "Sab",
        "Sun": "Min",
        "Please fill in all fields": "Silakan isi semua kolom",
        "Survey submitted successfully! We will contact you when the session is ready.": "Survei berhasil dikirim! Kami akan menghubungi Anda ketika sesi siap.",
        "Error submitting survey. Please try again.": "Kesalahan mengirim survei. Silakan coba lagi.",
        "Join TOPIK Session": "Gabung Sesi TOPIK",
        "Preferred Weekdays": "Hari yang Diinginkan",
        "My WhatsApp Number": "Nomor WhatsApp Saya",
        "Submitting...": "Mengirim...",
        "Submit": "Kirim",
        "⚠️ Penting:": "⚠️ Penting:",
        " Sesi terdiri dari 10 orang dengan sistem first come first served, dan jika sesi sudah terpenuhi, detail sesi dan link pembayaran akan dikirimkan kepada Anda.": " Sesi terdiri dari 10 orang dengan sistem first come first served, dan jika sesi sudah terpenuhi, detail sesi dan link pembayaran akan dikirimkan kepada Anda."
    },
    ko: {
        "Monday": "월요일",
        "Tuesday": "화요일",
        "Wednesday": "수요일",
        "Thursday": "목요일",
        "Friday": "금요일",
        "Saturday": "토요일",
        "Sunday": "일요일",
        "Mon": "월",
        "Tue": "화",
        "Wed": "수",
        "Thu": "목",
        "Fri": "금",
        "Sat": "토",
        "Sun": "일",
        "Please fill in all fields": "모든 필드를 입력해주세요",
        "Survey submitted successfully! We will contact you when the session is ready.": "설문이 성공적으로 제출되었습니다! 세션 준비가 완료되면 연락드리겠습니다.",
        "Error submitting survey. Please try again.": "설문 제출 중 오류가 발생했습니다. 다시 시도해주세요.",
        "Join TOPIK Session": "TOPIK 세션 참여하기",
        "Preferred Weekdays": "선호하는 요일",
        "My WhatsApp Number": "내 WhatsApp 번호",
        "Submitting...": "제출 중...",
        "Submit": "제출",
        "⚠️ Penting:": "⚠️ 중요:",
        " Sesi terdiri dari 10 orang dengan sistem first come first served, dan jika sesi sudah terpenuhi, detail sesi dan link pembayaran akan dikirimkan kepada Anda.": " 세션은 선착순으로 10명으로 구성되며, 세션이 가득 차면 세션 세부정보와 결제 링크가 전송됩니다."
    },
    vn: {
        "Monday": "Thứ Hai",
        "Tuesday": "Thứ Ba",
        "Wednesday": "Thứ Tư",
        "Thursday": "Thứ Năm",
        "Friday": "Thứ Sáu",
        "Saturday": "Thứ Bảy",
        "Sunday": "Chủ Nhật",
        "Mon": "T2",
        "Tue": "T3",
        "Wed": "T4",
        "Thu": "T5",
        "Fri": "T6",
        "Sat": "T7",
        "Sun": "CN",
        "Please fill in all fields": "Vui lòng điền đầy đủ thông tin",
        "Survey submitted successfully! We will contact you when the session is ready.": "Khảo sát đã được gửi thành công! Chúng tôi sẽ liên hệ với bạn khi buổi học sẵn sàng.",
        "Error submitting survey. Please try again.": "Lỗi khi gửi khảo sát. Vui lòng thử lại.",
        "Join TOPIK Session": "Tham gia Buổi TOPIK",
        "Preferred Weekdays": "Ngày trong tuần ưu tiên",
        "My WhatsApp Number": "Số WhatsApp của tôi",
        "Submitting...": "Đang gửi...",
        "Submit": "Gửi",
        "⚠️ Penting:": "⚠️ Quan trọng:",
        " Sesi terdiri dari 10 orang dengan sistem first come first served, dan jika sesi sudah terpenuhi, detail sesi dan link pembayaran akan dikirimkan kepada Anda.": " Buổi học bao gồm 10 người theo nguyên tắc ai đến trước được phục vụ trước, và khi buổi học đã đầy, chi tiết buổi học và liên kết thanh toán sẽ được gửi cho bạn."
    }
};


function Topik250725() {
    const productId = 'topik_II.250725.01';

    const [, forceUpdate] = useState({});
    const t = tLoader(translations);

    const [preferredWeekdays, setPreferredWeekdays] = useState<string[]>([]);
    const [countryCode, setCountryCode] = useState('+62');
    const [whatsappNumber, setWhatsappNumber] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    useEffect(() => {
        const unsubscribe = languageManager.subscribe(() => forceUpdate({}));
        return unsubscribe;
    }, []);

    const [columnWidth, setColumnWidth] = useState(300);
    useEffect(() => {
        const handleResize = () => {
            const newWidth = Math.min(window.innerWidth, 800);
            setColumnWidth(newWidth);
        };

        handleResize(); // Set initial width
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    const { sessionRefresh } = useSession();

    const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const weekdayLabels = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

    const handleWeekdayChange = (day: string) => {
        setPreferredWeekdays(prev => 
            prev.includes(day) 
                ? prev.filter(d => d !== day)
                : [...prev, day]
        );
    };

    useEffect(() => {
        // Log product view behavior if you have analytics
        sessionRefresh();
        console.log('TOPIK 250725 product viewed');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (preferredWeekdays.length === 0 || !whatsappNumber) {
            alert(t('Please fill in all fields'));
            return;
        }

        setIsSubmitting(true);
        try {
            const fullPhoneNumber = `${countryCode}${whatsappNumber}`;
            const currentDate = new Date().toLocaleString();
            
            // Create HTML email content
            const htmlContent = `
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="UTF-8">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <title>TOPIK 250725 Survey Submission</title>
                    <style>
                        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; margin: 0; padding: 20px; background-color: #f4f4f4; }
                        .container { max-width: 600px; margin: 0 auto; background: white; border-radius: 10px; overflow: hidden; box-shadow: 0 0 20px rgba(0,0,0,0.1); }
                        .header { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 30px; text-align: center; }
                        .content { padding: 30px; }
                        .info-table { width: 100%; border-collapse: collapse; margin: 20px 0; }
                        .info-table th, .info-table td { border: 1px solid #ddd; padding: 12px; text-align: left; }
                        .info-table th { background-color: #f8f9fa; font-weight: bold; }
                        .footer { background-color: #f8f9fa; padding: 20px; text-align: center; color: #666; font-size: 14px; }
                    </style>
                </head>
                <body>
                    <div class="container">
                        <div class="header">
                            <h1>🎯 TOPIK 250725 Survey Submission</h1>
                            <p>New participant registration</p>
                        </div>
                        <div class="content">
                            <h2>Survey Details</h2>
                            <table class="info-table">
                                <tr>
                                    <th>Field</th>
                                    <th>Response</th>
                                </tr>
                                <tr>
                                    <td><strong>Preferred Weekdays</strong></td>
                                    <td>${preferredWeekdays.join(', ')}</td>
                                </tr>
                                <tr>
                                    <td><strong>WhatsApp Number</strong></td>
                                    <td>${fullPhoneNumber}</td>
                                </tr>
                                <tr>
                                    <td><strong>Product ID</strong></td>
                                    <td>${productId}</td>
                                </tr>
                                <tr>
                                    <td><strong>Submission Date</strong></td>
                                    <td>${currentDate}</td>
                                </tr>
                            </table>
                            
                            <div style="background-color: #fff3cd; border: 1px solid #ffeaa7; border-radius: 8px; padding: 15px; margin: 20px 0;">
                                <p><strong>⚠️ Action Required:</strong> Session consists of 10 people on a first-come-first-served basis. Please process this registration and send session details + payment link when ready.</p>
                            </div>
                        </div>
                        <div class="footer">
                            <p>This email was generated automatically from the TOPIK 250725 product page.</p>
                            <p>Korean Mate • <a href="https://koreanmate.app">koreanmate.app</a></p>
                        </div>
                    </div>
                </body>
                </html>
            `;

            // Send email to dl_mate
            const response = await axios.post('/admin/trigger-email', {
                email: 'dl_mate@webtoon.today',
                subject: `[🎯TOPIK II] Class survey`,
                body: htmlContent,
                groups: 'dl_mate@webtoon.today'
            });

            if (response.data && response.data.code === 200) {
                alert(t('Survey submitted successfully! We will contact you when the session is ready.'));
                setPreferredWeekdays([]);
                setCountryCode('+62');
                setWhatsappNumber('');
                setIsSubmitted(true);
            } else {
                throw new Error('Email sending failed');
            }
        } catch (error) {
            console.error('Error submitting survey:', error);
            alert(t('Error submitting survey. Please try again.'));
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="topik-250725-page">
            <div className="topik-content">
                <div className="topik-detail-page">
                    <TopikImage
                        src={'https://static.koreanmate.app/product/topik-250725/MATE_TOPIK2_class_001.png'}
                        alt={`TOPIK 250725 Detail Page 001`}
                        className="detail-page-slice"
                    />
                    <TopikImage
                        src={'https://static.koreanmate.app/product/topik-250725/MATE_TOPIK2_class_002.png'}
                        alt={`TOPIK 250725 Detail Page 001`}
                        className="detail-page-slice"
                    />
                    <div className="video-container">
                        <iframe
                            width={columnWidth} height={columnWidth / 560 * 315}
                            src="https://www.youtube.com/embed/R8p177f-1YU?si=JYLkamue7pK9vN27"
                            title="YouTube video player" frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen
                        />
                    </div>
                    <TopikImage
                        src={'https://static.koreanmate.app/product/topik-250725/MATE_TOPIK2_class_003.png'}
                        alt={`TOPIK 250725 Detail Page 001`}
                        className="detail-page-slice"
                    />
                    <TopikImage
                        src={'https://static.koreanmate.app/product/topik-250725/MATE_TOPIK2_class_004.png'}
                        alt={`TOPIK 250725 Detail Page 001`}
                        className="detail-page-slice"
                    />
                    <TopikImage
                        src={'https://static.koreanmate.app/product/topik-250725/MATE_TOPIK2_class_005.png'}
                        alt={`TOPIK 250725 Detail Page 001`}
                        className="detail-page-slice"
                    />
                    <TopikImage
                        src={'https://static.koreanmate.app/product/topik-250725/MATE_TOPIK2_class_006.png'}
                        alt={`TOPIK 250725 Detail Page 001`}
                        className="detail-page-slice"
                    />
                    <TopikImage
                        src={'https://static.koreanmate.app/product/topik-250725/MATE_TOPIK2_class_007.png'}
                        alt={`TOPIK 250725 Detail Page 001`}
                        className="detail-page-slice"
                    />
                    <TopikImage
                        src={'https://static.koreanmate.app/product/topik-250725/MATE_TOPIK2_class_008.png'}
                        alt={`TOPIK 250725 Detail Page 001`}
                        className="detail-page-slice"
                    />
                    <TopikImage
                        src={'https://static.koreanmate.app/product/topik-250725/MATE_TOPIK2_class_008.5.png'}
                        alt={`TOPIK 250725 Detail Page 001`}
                        className="detail-page-slice"
                    />
                    <TopikImage
                        src={'https://static.koreanmate.app/product/topik-250725/MATE_TOPIK2_class_009.png'}
                        alt={`TOPIK 250725 Detail Page 001`}
                        className="detail-page-slice"
                    />
                </div>

                <div id={"CTA"} className="survey-section">
                    <form onSubmit={handleSubmit} className="topik-survey-form">
                        <h3>{t("Join TOPIK Session")}</h3>

                        <div className="form-group">
                            <label>{t("Preferred Weekdays")}</label>
                            <div className="button-group">
                                {weekdays.map((day, index) => (
                                    <button
                                        key={day}
                                        type="button"
                                        className={`weekday-button ${preferredWeekdays.includes(day) ? 'selected' : ''} ${day === 'Saturday' || day === 'Sunday' ? 'weekend' : ''}`}
                                        onClick={() => handleWeekdayChange(day)}
                                    >
                                        {t(weekdayLabels[index])}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="whatsapp">{t("My WhatsApp Number")}</label>
                            <div className="phone-input">
                                <input
                                    type="text"
                                    className="country-code-input"
                                    value={countryCode}
                                    onChange={(e) => setCountryCode(e.target.value)}
                                    placeholder="+62"
                                />
                                <input
                                    type="tel"
                                    id="whatsapp"
                                    value={whatsappNumber}
                                    onChange={(e) => setWhatsappNumber(e.target.value)}
                                    placeholder="8000000000000"
                                    required
                                />
                            </div>
                        </div>

                        <button type="submit" disabled={isSubmitting || isSubmitted} className="submit-button">
                            {isSubmitting ? t('Submitting...') : t('Submit')}
                        </button>

                        <div className="warning-message">
                            <p>
                                <strong>{t("⚠️ Penting:")}</strong>{t(" Sesi terdiri dari 10 orang dengan sistem first come first served, dan jika sesi sudah terpenuhi, detail sesi dan link pembayaran akan dikirimkan kepada Anda.")}
                            </p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Topik250725;